export const DAYS = [9, 10, 11, 12, 13];

export function trainingDays(services) {
  const set = new Set();
  ["football", "goalkeeper"].forEach((k) => {
    const s = services[k] || {};
    if (s.type === "daily" || s.type === "double") DAYS.forEach((d) => set.add(d));
    if (s.type === "individual") Object.entries(s.days || {}).forEach(([d, c]) => { if (c > 0) set.add(Number(d)); });
  });
  return set;
}

export function useServiceActions(participant, onChange) {
  const svc = participant.services;
  const update = (patch) => onChange({ ...participant, services: { ...svc, ...patch } });
  const withMeals = (newServices) => {
    const td = trainingDays(newServices);
    const meals = (svc.meals.days || []).filter((d) => td.has(d));
    onChange({ ...participant, services: { ...newServices, meals: { days: meals } } });
  };

  const setTrainingType = (key, type) => {
    withMeals({ ...svc, [key]: { ...svc[key], type, days: type === "individual" ? (svc[key].days || {}) : {} } });
  };
  const cycleDay = (key, day, max) => {
    const days = { ...(svc[key].days || {}) };
    const nxt = (days[day] || 0) + 1 > max ? 0 : (days[day] || 0) + 1;
    if (nxt === 0) delete days[day]; else days[day] = nxt;
    withMeals({ ...svc, [key]: { ...svc[key], days } });
  };
  const toggleFeedbackType = (type) => {
    if (svc.development_package && type !== "none") return;
    update({ feedback: { type, days: type === "individual" ? (svc.feedback.days || {}) : {} } });
  };
  const cycleFeedbackDay = (day) => {
    const days = { ...(svc.feedback.days || {}) };
    if (days[day]) delete days[day]; else days[day] = 1;
    update({ feedback: { ...svc.feedback, days } });
  };
  const toggleDevelopment = () => {
    if (svc.development_package) update({ development_package: false });
    else update({ development_package: true, feedback: { type: "none", days: {} } });
  };
  const toggleMeal = (day) => {
    if (!trainingDays(svc).has(day)) return;
    const days = new Set(svc.meals.days || []);
    if (days.has(day)) days.delete(day); else days.add(day);
    update({ meals: { days: [...days].sort((a, b) => a - b) } });
  };
  const setDietary = (meal_dietary) => onChange({ ...participant, meal_dietary });

  return { setTrainingType, cycleDay, toggleFeedbackType, cycleFeedbackDay, toggleDevelopment, toggleMeal, setDietary };
}
